import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import ClassificationInformationsSelect from "@/components/ClassificationInformationsSelect.vue";
import MunicipalitySelect from "@/components/MunicipalitySelect.vue";
import { useValidateProps } from "@/composables/fields";
import { dbEnums } from "@/types/enums/dbEnums";
import { DraftStartupperDto } from "@api/draft-startupper-dto";
import { PropType, computed, watch } from "vue";
import { BusinessIdeaFieldCategoryMap } from "..";
import { isMobileReactive } from "@/helpers";
import Field from "../../Field.vue";
import FormFields from "../../FormFields.vue";
import FormSection from "../../FormSection.vue";
import FormSectionHeader from "../../FormSectionHeader.vue";
import Tol2008Picker from "@/components/Tol2008Picker.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StartupperFormBusinessIdeaBasicFields',
  props: {
	fieldsMap: {
		type: Object as PropType<BusinessIdeaFieldCategoryMap>,
		required: true,
	},
	modelValue: {
		type: Object as PropType<DraftStartupperDto>,
		required: true,
	},
	noBusinessIdea: {
		type: Boolean as PropType<boolean>,
		required: false,
		default: () => false,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const fields = dbEnums.BusinessIdeaFields;

const props = __props;

const emit = __emit;

const formDataComputed = computed({
	get() {
		return props.modelValue;
	},
	set(v) {
		emit("update:modelValue", v);
	},
});

const validateProps = useValidateProps();

watch(
	() => props.noBusinessIdea,
	(val) => {
		if (val) formDataComputed.value.businessIdeaName = "Ei yritysideaa";
		else formDataComputed.value.businessIdeaName = "";
	},
	{ immediate: false }
);

return (_ctx: any,_cache: any) => {
  const _component_HakoInput = _resolveComponent("HakoInput")!
  const _component_HakoTextArea = _resolveComponent("HakoTextArea")!

  return (_openBlock(), _createBlock(FormSection, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FormSectionHeader, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("startupperForm.sectionHeaders.businessIdeaBasicInfo")), 1)
            ]),
            _: 1
          })
        ]),
        _renderSlot(_ctx.$slots, "default"),
        (!__props.noBusinessIdea && __props.fieldsMap.Basic)
          ? (_openBlock(), _createBlock(FormFields, {
              key: 0,
              fields: __props.fieldsMap.Basic.fields
            }, {
              [_unref(fields).Name]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.businessIdeaName"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoInput, {
                      modelValue: formDataComputed.value.businessIdeaName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formDataComputed.value.businessIdeaName) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      style: {"max-width":"500px"}
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).Description]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.businessIdeaDescription"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.businessIdeaDescription,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formDataComputed.value.businessIdeaDescription) = $event)),
                      id: elementId
                    }, null, 8, ["modelValue", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).Municipality]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.businessIdeaMunicipalityId"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(MunicipalitySelect, {
                      valueSingle: formDataComputed.value.businessIdeaMunicipality,
                      "onUpdate:valueSingle": _cache[2] || (_cache[2] = ($event: any) => ((formDataComputed.value.businessIdeaMunicipality) = $event)),
                      valueSingleId: formDataComputed.value.businessIdeaMunicipalityId,
                      "onUpdate:valueSingleId": _cache[3] || (_cache[3] = ($event: any) => ((formDataComputed.value.businessIdeaMunicipalityId) = $event)),
                      ajax: "",
                      style: {"max-width":"250px"}
                    }, null, 8, ["valueSingle", "valueSingleId"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).BusinessPremiseRequirement]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.businessIdeaPremiseRequirementId"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(ClassificationInformationsSelect, {
                      valueSingle: formDataComputed.value.businessIdeaBusinessPremiseRequirement,
                      "onUpdate:valueSingle": _cache[4] || (_cache[4] = ($event: any) => ((formDataComputed.value.businessIdeaBusinessPremiseRequirement) = $event)),
                      valueSingleId: 
								formDataComputed.value.businessIdeaBusinessPremiseRequirementId
							,
                      "onUpdate:valueSingleId": _cache[5] || (_cache[5] = ($event: any) => ((
								formDataComputed.value.businessIdeaBusinessPremiseRequirementId
							) = $event)),
                      infoTable: "BusinessPremiseRequirements",
                      translationsTable: "BusinessPremiseRequirementTranslations",
                      translationProperty: "name",
                      ajax: false,
                      style: {"max-width":"250px"}
                    }, null, 8, ["valueSingle", "valueSingleId"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).BusinessFieldGroup]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.businessIdeaBusinessFieldGroupId"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(ClassificationInformationsSelect, {
                      valueSingle: formDataComputed.value.businessIdeaBusinessFieldGroup,
                      "onUpdate:valueSingle": _cache[6] || (_cache[6] = ($event: any) => ((formDataComputed.value.businessIdeaBusinessFieldGroup) = $event)),
                      valueSingleId: formDataComputed.value.businessIdeaBusinessFieldGroupId,
                      "onUpdate:valueSingleId": _cache[7] || (_cache[7] = ($event: any) => ((formDataComputed.value.businessIdeaBusinessFieldGroupId) = $event)),
                      infoTable: "BusinessFieldGroups",
                      translationsTable: "BusinessFieldGroupTranslations",
                      translationProperty: "name",
                      ajax: false,
                      style: {"max-width":"250px"}
                    }, null, 8, ["valueSingle", "valueSingleId"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).BusinessField]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.businessIdeaBusinessFieldId"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(ClassificationInformationsSelect, {
                      valueSingle: formDataComputed.value.businessIdeaBusinessField,
                      "onUpdate:valueSingle": _cache[8] || (_cache[8] = ($event: any) => ((formDataComputed.value.businessIdeaBusinessField) = $event)),
                      valueSingleId: formDataComputed.value.businessIdeaBusinessFieldId,
                      "onUpdate:valueSingleId": _cache[9] || (_cache[9] = ($event: any) => ((formDataComputed.value.businessIdeaBusinessFieldId) = $event)),
                      infoTable: "BusinessFields",
                      translationsTable: "BusinessFieldTranslations",
                      translationProperty: "name",
                      ajax: false,
                      style: {"max-width":"250px"}
                    }, null, 8, ["valueSingle", "valueSingleId"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).Tol2008]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.businessIdeaTol2008"
                }, {
                  default: _withCtx(() => [
                    _createVNode(Tol2008Picker, {
                      modelValue: formDataComputed.value.businessIdeaTol2008,
                      "onUpdate:modelValue": [
                        _cache[10] || (_cache[10] = ($event: any) => ((formDataComputed.value.businessIdeaTol2008) = $event)),
                        _cache[11] || (_cache[11] = ($event: any) => (
								formDataComputed.value.businessIdeaTol2008Id = $event?.id ?? null
							))
                      ]
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).BusinessIdeaType]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.businessIdeaTypeId"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(ClassificationInformationsSelect, {
                      valueSingle: formDataComputed.value.businessIdeaType,
                      "onUpdate:valueSingle": _cache[12] || (_cache[12] = ($event: any) => ((formDataComputed.value.businessIdeaType) = $event)),
                      valueSingleId: formDataComputed.value.businessIdeaTypeId,
                      "onUpdate:valueSingleId": _cache[13] || (_cache[13] = ($event: any) => ((formDataComputed.value.businessIdeaTypeId) = $event)),
                      infoTable: "BusinessIdeaTypes",
                      translationsTable: "BusinessIdeaTypeTranslations",
                      translationProperty: "name",
                      ajax: false,
                      style: {"max-width":"500px"}
                    }, null, 8, ["valueSingle", "valueSingleId"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).EmploysTotal]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  "property-path": "draftStartupperData.employsTotal"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(_component_HakoInput, {
                      type: "number",
                      modelValue: formDataComputed.value.employsTotal,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formDataComputed.value.employsTotal) = $event)),
                      modelModifiers: { number: true }
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).EmploysEntrepreneurs]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  "property-path": "draftStartupperData.employsEntrepreneurs"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(_component_HakoInput, {
                      type: "number",
                      modelValue: formDataComputed.value.employsEntrepreneurs,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formDataComputed.value.employsEntrepreneurs) = $event)),
                      modelModifiers: { number: true }
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).EmploysFullTime]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  "property-path": "draftStartupperData.employsFulltime"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(_component_HakoInput, {
                      type: "number",
                      modelValue: formDataComputed.value.employsFulltime,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formDataComputed.value.employsFulltime) = $event)),
                      modelModifiers: { number: true }
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).EmploysPartTime]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  "property-path": "draftStartupperData.employsParttime"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(_component_HakoInput, {
                      type: "number",
                      modelValue: formDataComputed.value.employsParttime,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formDataComputed.value.employsParttime) = $event)),
                      modelModifiers: { number: true }
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).EmploysJobSearchers]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  "property-path": "draftStartupperData.employsUnemployed"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(_component_HakoInput, {
                      type: "number",
                      modelValue: formDataComputed.value.employsUnemployed,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formDataComputed.value.employsUnemployed) = $event)),
                      modelModifiers: { number: true }
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).EmploysWomen]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  "property-path": "draftStartupperData.employsWomen"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(_component_HakoInput, {
                      type: "number",
                      modelValue: formDataComputed.value.employsWomen,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formDataComputed.value.employsWomen) = $event)),
                      modelModifiers: { number: true }
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).EmploysYouth]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  "property-path": "draftStartupperData.employsYouth"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(_component_HakoInput, {
                      type: "number",
                      modelValue: formDataComputed.value.employsYouth,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formDataComputed.value.employsYouth) = $event)),
                      modelModifiers: { number: true }
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              _: 2
            }, 1032, ["fields"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }))
}
}

})